export default "__VITE_ASSET__DOqmabFR__"